import { useTranslation } from 'react-i18next'

import { Button } from '../../index'
import { CurrencyInputField } from '../../CurrencyInputField'
import { deleteBillingService, findMinimumFee, isMinimumFeeValid, upsertMinimumFee } from '../utils'
import { SERVICE_TYPES } from '../constants'

// Optional: a store without a minimum fee simply has no MINIMUM_FEE row.
const MinimumFeeService = ({ storeBillingServices, onUpdateStoreBillingServices, storeId, warehouse, currency }) => {
  const { i18n } = useTranslation()

  const minimumFee = findMinimumFee(storeBillingServices)
  const price = minimumFee?.price_configuration?.[0]?.price
  const showError = Boolean(minimumFee) && !isMinimumFeeValid(storeBillingServices)

  const handleOnChangePrice = newPrice => {
    onUpdateStoreBillingServices(
      upsertMinimumFee(storeBillingServices, {
        price: newPrice === '' ? null : newPrice,
        currency,
        storeId,
        warehouseId: warehouse?.id,
      }),
    )
  }

  const handleOnAdd = () => handleOnChangePrice(null)

  const handleOnRemove = () => {
    onUpdateStoreBillingServices(deleteBillingService({ serviceType: SERVICE_TYPES.SERVICE_MINIMUM_FEE, billingServices: storeBillingServices }))
  }

  return (
    <div className="mt-8">
      <h2 className="text-xl text-gray-500">{i18n.t('billing.minimum_fee_services.minimum_fee_title')}</h2>
      <p className="text-gray-400 mb-2">{i18n.t('billing.minimum_fee_services.helper')}</p>

      {minimumFee ? (
        <div className="flex items-end gap-4">
          <CurrencyInputField
            className="w-64"
            title={i18n.t('billing.minimum_fee_services.amount_label')}
            required={true}
            value={price === null || price === undefined ? '' : price}
            onChange={handleOnChangePrice}
            customIcon={<div className="font-bold">{currency}</div>}
            inputClassName="pl-12"
            scale={2}
            precision={13}
          />
          <Button type="secondary" onClick={handleOnRemove}>
            {i18n.t('billing.minimum_fee_services.remove')}
          </Button>
        </div>
      ) : (
        <Button type="secondary" onClick={handleOnAdd}>
          {i18n.t('billing.minimum_fee_services.add')}
        </Button>
      )}

      {showError && <div className="text-red-500 italic mt-2">{i18n.t('billing.minimum_fee_services.errors.INVALID_AMOUNT')}</div>}
    </div>
  )
}

export default MinimumFeeService
